import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { handleSetOpenCustomSnackbar } from '../../../../redux/actions/snackbar';
import { useEffect } from 'react';
import { handleChangeDataModalSuccessMsg } from '../../../../redux/actions/partials/modals/modalSuccessMsg';
import { handleChangeDataModalErrorMsg } from '../../../../redux/actions/partials/modals/modalErrorMsg';

const Payment = () => {

	const dispatch = useDispatch();

    const { token, profile } = useSelector(state => state.login);

    const [ params ] = useSearchParams();
    const status = params.get("status")?.trim() || "";
    const orderCode = params.get("orderCode")?.trim() || "";
    const message = params.get("message")?.trim() || "";

    useEffect(() => {
        if(status === "OK") {
            dispatch(handleChangeDataModalSuccessMsg('isOpen', true));
            setTimeout(() => dispatch(handleChangeDataModalSuccessMsg('isActive', true)), 0);
        }
        else {
            dispatch(handleChangeDataModalErrorMsg('title', 'خطا'));
            let msg = "خطا در ثبت سفارش";
            if(message.length > 0)
                msg += ("\n" + message);

            dispatch(handleChangeDataModalErrorMsg('message', msg));
            dispatch(handleChangeDataModalErrorMsg('isOpen', true));
            setTimeout(() => dispatch(handleChangeDataModalErrorMsg('isActive', true)), 0);
        }
    }, [status, message]);

    

    return (
        
        <div>

		</div>

    );
}

export default Payment;